/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "interaction",
            "endpoint": "https://f3wxwm9fwf.execute-api.us-east-1.amazonaws.com/staging",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://f6apqfoobrbcvnuq76cbnrbak4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-7u55wkjg75dkbo254gjrxrcrbe",
    "aws_cognito_identity_pool_id": "us-east-1:2d20518d-feb1-46ff-87ad-ac45fae61eb1",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_qRTW6SLkg",
    "aws_user_pools_web_client_id": "cjl4a400vdi0tomqnmq7soqcu",
    "oauth": {
        "domain": "sentientsimulations.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://otge3rc4iiuuouv33hb3ac4zny0nogyj.lambda-url.us-east-1.on.aws,http://localhost:25149/oauth2/idpresponse,https://www.sentientsimulations.com",
        "redirectSignOut": "https://otge3rc4iiuuouv33hb3ac4zny0nogyj.lambda-url.us-east-1.on.aws,http://localhost:25149/oauth2/idpresponse,https://www.sentientsimulations.com",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
